import React from 'react';

import thunk from 'redux-thunk';

import { applyMiddleware, compose, createStore } from 'redux';
import { connect, Provider } from 'react-redux';
import reducer, { APPLICATION, USER } from '../data/reducer';
import { FormattedMessage, IntlProvider } from 'react-intl';
import locale_fi from '../lang/messages.fi.json';

import api from '../api/Api';

import { initializeApplication } from '../data/user/profile/actions';
import Alert from '../components/Alert';
import AgreementBase from './AgreementBase';
import ApplicationBase from './ApplicationBase';
import Loader from '../components/Loader';
import {
  INITIALIZATION_FAILED,
  NOT_INITIALIZED,
} from '../data/application/reducer';
import { OTLink } from '../components/tag/OTLink';
import SessionUtils from '../utils/SessionUtils';
import Misc from '../definitions/Misc';
import TosUpdated from '../components/agreement/tosupdated/TosUpdated';

if (process.env.NODE_ENV !== 'production') {
  let withMockPaths = require('../api/withMockPaths').default;
  console.log('MOCKING API');
  withMockPaths(api);
}

const services = {
  api: api,
};

const thunkExtended = thunk.withExtraArgument(services);

const middleware = [thunkExtended];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(...middleware))
);

const messages = {
  fi: locale_fi,
};

const language = 'fi';

api.store = store;
api.createMethods();

class AppContainer extends React.Component {
  componentDidMount() {
    let { initializeValues } = this.props;
    initializeValues();

    // do document related initialization here.
    // getting title of document and change the "skip to content" link
    // Misc.setPageTitleBase(document.title);
    Misc.setPageTitleBase('OmaTays');
  }

  render() {
    let { applicationState, loggedIn, isUser, agreementUserInfo } = this.props;

    // if initialization fails, show logout button and ask to fill a
    // feedback form.
    if (applicationState === INITIALIZATION_FAILED) {
      return (
        <Alert>
          <div>
            <div>
              <FormattedMessage
                id="application.initialization.failed"
                values={{
                  a: (chunks) => (
                    <a
                      href="https://q.surveypal.com/OmaTays-vikailmoitus-v2"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {chunks}
                    </a>
                  ),
                }}
              />
            </div>
            <div>
              <OTLink isExternal onClick={() => SessionUtils.logout()}>
                <FormattedMessage id="application.initialization.failed.log.out" />
              </OTLink>
            </div>
          </div>
        </Alert>
      );
    }

    if (
      applicationState === NOT_INITIALIZED ||
      loggedIn === undefined ||
      isUser === undefined
    ) {
      return <Loader />;
    }

    if (!loggedIn) {
      return <Alert isHtml message="application.user.not.logged.in" />;
    }

    if (isUser) {
      if (
        this.props.tosVersion == null ||
        this.props.tosVersion === this.props.userInfo.tosVersion
      ) {
        return <ApplicationBase />;
      } else {
        return <TosUpdated />;
      }
    } else {
      return <AgreementBase agreementUserInfo={agreementUserInfo} />;
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    initializeValues: () => dispatch(initializeApplication()),
  };
};

const mapStateToProps = (state) => {
  return {
    applicationState: state[APPLICATION].applicationState,
    loggedIn: state[USER].userInfo.loggedIn,
    isUser: state[USER].userInfo.isUser,
    agreementUserInfo: state[USER].userInfo.agreementUserInfo,
    userInfo: state[USER].userInfo.data,
    tosVersion: state[USER].userInfo.tosVersion,
  };
};

const ConnectedAppContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppContainer);

const StateContainer = () => (
  <Provider store={store}>
    <IntlProvider
      locale={language}
      messages={messages[language]}
      textComponent="span"
      defaultRichTextElements={{
        h1: (msg) => <h1>{msg}</h1>,
        h2: (msg) => <h2>{msg}</h2>,
        h3: (msg) => <h3>{msg}</h3>,
        h4: (msg) => <h4>{msg}</h4>,
        h5: (msg) => <h5>{msg}</h5>,
        h6: (msg) => <h6>{msg}</h6>,
        b: (msg) => <b>{msg}</b>,
        strong: (msg) => <strong>{msg}</strong>,
        br: (msg) => <br>{msg}</br>,
        span: (msg) => <span>{msg}</span>,
        a: (msg) => <a>{msg}</a>,
      }}
    >
      <ConnectedAppContainer />
    </IntlProvider>
  </Provider>
);

export default StateContainer;
